import { Box } from "@mui/material";
import { useState } from "react";
import { Alert } from "react-bootstrap";

import intPartnersImg from "images/niap_ccevs/int_partners.png";
import ApprovedProductsLogo from "images/products/ApprovedProducts.png";
import ArchivedProductsLogo from "images/products/ArchivedProducts.png";
import CertifyANewProductLogo from "images/products/CertifyANewProduct.png";
import InEvaluationProductsLogo from "images/products/ProductsInEvaluation.png";

import ApprovedProductsModal from "./ApprovedProductsModal";
import ArchivedProductsModal from "./ArchivedProductsModal";
import PclHeaderCard from "./PclHeaderCard";
import ProductsInEvalModal from "./ProductsInEvalModal";
import ProposeInternationalProductModal from "./ProposeInternationalProductModal/ProposeInternationalProduct.modal";

export default function PclModals() {
  const [showApprovedModal, setShowApprovedModal] = useState(false);
  const [showEvalModal, setShowEvalModal] = useState(false);
  const [showArchivedModal, setShowArchivedModal] = useState(false);
  const [showIntModal, setShowIntModal] = useState(false);

  const [alert, setAlert] = useState({ message: "", type: "" });

  const toggleApprovedModal = () => setShowApprovedModal(!showApprovedModal);
  const toggleProductsInEvalModal = () => setShowEvalModal(!showEvalModal);
  const toggleArchivedModal = () => setShowArchivedModal(!showArchivedModal);
  const toggleIntModal = () => setShowIntModal(!showIntModal);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      paddingY={3}
      flexWrap="wrap"
    >
      {alert.message !== "" && (
        <Box flex="1 1 90%" margin={2}>
          <Alert
            variant={alert.type}
            dismissible
            onClose={() => setAlert({ message: "", type: "" })}
          >
            {alert.message}
          </Alert>
        </Box>
      )}

      <PclHeaderCard
        label={"Certify a New Product"}
        icon={CertifyANewProductLogo}
        buttonText={"CCTLs"}
        linkPath={"/cctl"}
        additionalContent={<p>See the List of approved CCTLs</p>}
      />

      <PclHeaderCard
        label={"Compliant Products"}
        icon={ApprovedProductsLogo}
        buttonText={"Learn More"}
        onClick={toggleApprovedModal}
        additionalContent={
          <ApprovedProductsModal
            showModal={showApprovedModal}
            handleShowModal={toggleApprovedModal}
          />
        }
      />

      <PclHeaderCard
        label={"Products In Evaluation"}
        icon={InEvaluationProductsLogo}
        buttonText={"Learn More"}
        onClick={toggleProductsInEvalModal}
        additionalContent={
          <ProductsInEvalModal
            showModal={showEvalModal}
            handleShowModal={toggleProductsInEvalModal}
          />
        }
      />

      <PclHeaderCard
        label={"International Posting"}
        icon={intPartnersImg}
        buttonText={"Propose"}
        onClick={toggleIntModal}
        additionalContent={
          showIntModal && (
            <ProposeInternationalProductModal
              show={showIntModal}
              onClose={toggleIntModal}
              setAlert={setAlert}
            />
          )
        }
      />

      <PclHeaderCard
        label={"Archived Products"}
        icon={ArchivedProductsLogo}
        buttonText={"Learn More"}
        onClick={toggleArchivedModal}
        additionalContent={
          <ArchivedProductsModal
            showModal={showArchivedModal}
            handleShowModal={toggleArchivedModal}
          />
        }
      />
    </Box>
  );
}
